/**
 * Mobile customize PDP: pin the product gallery 10px below the viewport top
 * and shrink it to 25dvh while scrolling.
 */
const initPdpGallerySticky = () => {
	const main = document.querySelector('[data-template="product"]');
	const galleryWrap = document.querySelector('.gallery-wrap');

	if (!main || !galleryWrap || !main.querySelector('unitmoq-product-preview')) {
		return;
	}

	const mq = window.matchMedia('(max-width: 749px)');
	let fullHeight = 0;
	let stickyStart = 0;
	let shrinkDistance = 0;
	let ticking = false;
	let wasHidden = galleryWrap.classList.contains('hidden');

	const getMinHeight = () => window.innerHeight * 0.25;

	const deactivate = () => {
		galleryWrap.style.removeProperty('--pdp-gallery-wrap-height');
		galleryWrap.classList.remove('is-gallery-fixed');
	};

	const reset = () => {
		deactivate();
		galleryWrap.style.removeProperty('--pdp-gallery-left');
		galleryWrap.style.removeProperty('--pdp-gallery-width');
	};

	const measure = () => {
		reset();
		fullHeight = galleryWrap.offsetHeight;

		if (!fullHeight) {
			return;
		}

		const minHeight = getMinHeight();
		const galleryRect = galleryWrap.getBoundingClientRect();
		stickyStart = galleryRect.top + window.scrollY - 10;
		shrinkDistance = Math.max(fullHeight - minHeight, 120);
		galleryWrap.style.setProperty('--pdp-gallery-left', `${galleryRect.left}px`);
		galleryWrap.style.setProperty('--pdp-gallery-width', `${galleryRect.width}px`);
	};

	const update = () => {
		if (!mq.matches || galleryWrap.classList.contains('hidden')) {
			fullHeight = 0;
			reset();
			return;
		}

		if (!fullHeight) {
			measure();
		}

		if (!fullHeight) {
			return;
		}

		const minHeight = getMinHeight();
		const scrolled = Math.max(0, window.scrollY - stickyStart);
		const progress = Math.min(1, scrolled / shrinkDistance);

		if (progress === 0) {
			deactivate();
			return;
		}

		const height = fullHeight - progress * (fullHeight - minHeight);

		galleryWrap.style.setProperty('--pdp-gallery-wrap-height', `${height}px`);
		galleryWrap.classList.toggle('is-gallery-fixed', progress > 0);
	};

	const onScroll = () => {
		if (ticking) {
			return;
		}

		ticking = true;
		requestAnimationFrame(() => {
			update();
			ticking = false;
		});
	};

	const onResize = () => {
		fullHeight = 0;
		measure();
		update();
	};

	const classObserver = new MutationObserver(() => {
		const isHidden = galleryWrap.classList.contains('hidden');

		if (isHidden === wasHidden) {
			return;
		}

		wasHidden = isHidden;

		if (isHidden) {
			fullHeight = 0;
			reset();
			return;
		}

		requestAnimationFrame(() => {
			fullHeight = 0;
			measure();
			update();
		});
	});

	classObserver.observe(galleryWrap, { attributes: true, attributeFilter: ['class'] });

	const resizeObserver = new ResizeObserver(() => {
		if (galleryWrap.classList.contains('hidden') || galleryWrap.classList.contains('is-gallery-fixed')) {
			return;
		}

		fullHeight = 0;
		measure();
		update();
	});
	resizeObserver.observe(galleryWrap);

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onResize, { passive: true });
	mq.addEventListener('change', onResize);

	if (!galleryWrap.classList.contains('hidden')) {
		measure();
		update();
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initPdpGallerySticky);
} else {
	initPdpGallerySticky();
}
